module.exports = __webpack_public_path__ + "static/media/introduce.9ea2b4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200厢式车/introduce.png
// module id = 713
// module chunks = 0